import isEmpty from 'lodash/isEmpty'

export default (recipe, type = 'full_lg') => {

  if (recipe && !isEmpty(recipe.images)) {
    return recipe.images[type];
  }
}